export default __webpack_public_path__ + "static/media/arrow_up_enabled.336166fc.svg";